import React from 'react';

// Styles & Assets
import styles from './TablePollActions.module.css';
import { MdEdit } from 'react-icons/md';
import { ReactComponent as ViewDocumentSVG } from '../../../assets/icons/view_document.svg';
import { ReactComponent as BinSVG } from '../../../assets/icons/bin.svg';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';
import { canUserUpdateInquiries } from '../../../services/Poll';

// Context
import ScoresContext from '../../../context/ScoresContext';

// Hooks
import { useState, useContext } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import Modal from '../../UI/Modal/Modal';
import ViewPollDialog from '../ViewPollDialog/ViewPollDialog';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Interfaces
import { Poll } from '../../../interfaces/Poll';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';

const TablePollActions: React.FC<{
    poll: Poll,
    setPolls: React.Dispatch<React.SetStateAction<Poll[]>>
}> = ({ poll, setPolls }) => {

    const { t } = useTranslation();

    const { setScores } = useContext(ScoresContext);

    const [isViewPoll, setisViewPoll] = useState<boolean>(false);
    const [pollView, setPollView] = useState<Poll | null>(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
    const [pollDeleteId, setPollDeleteId] = useState<number | null>(null);

    const { sendRequest: deleteInquiry } = useHttp();

    const handleViewPollClick = (poll: Poll, evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        evt.stopPropagation();
        setisViewPoll(true);
        setPollView(poll);
    };

    const handleDeletePollClick = (poll: Poll, evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        evt.stopPropagation();
        if (poll.id === undefined) return;
        setShowDeleteDialog(true);
        setPollDeleteId(poll.id);
    };

    const handleConfirmClick = () => {
        deleteInquiry({
            url: getEnvironmentApiUrl() + `inquiry/${pollDeleteId}/logic`,
            method: 'DELETE',
        }, () => {
            setPolls(oldPolls => oldPolls.filter(oldPoll => oldPoll.id !== pollDeleteId));
            setScores(oldScores => oldScores === null ? null : oldScores.filter(sc => sc.inquiry_id !== pollDeleteId));
        }
        );
        setShowDeleteDialog(false);
    };

    const canUpdateInquiry = canUserUpdateInquiries();

    return (
        <>
            <div className={styles.buttonsActions}>
                <button onClick={(evt) => handleViewPollClick(poll as Poll, evt)} className={styles.buttonIcon}>
                    <ViewDocumentSVG className={styles.actionIcon} />
                </button>
                <Link
                    to={`edit_poll/${(poll as Poll).id}`}
                    state={{ poll }}
                    onClick={(e) => !canUpdateInquiry && e.preventDefault()} 
                    className={`${styles.buttonIcon} ${!canUpdateInquiry ? styles.disabled : ''}`}
                >
                    <MdEdit className={styles.actionIcon} />
                </Link>
                <button
                    onClick={(evt) => handleDeletePollClick(poll as Poll, evt)}
                    className={`${styles.buttonIcon} ${!canUpdateInquiry ? styles.disabled : ''}`}
                    disabled={!canUpdateInquiry}
                >
                    <BinSVG className={styles.actionIcon} />
                </button>
            </div>
            <Modal show={isViewPoll} setShowModal={setisViewPoll}>
                {pollView !== null && <ViewPollDialog
                    modalOpened={setisViewPoll}
                    poll={pollView}
                />}
            </Modal>
            <Modal show={showDeleteDialog} setShowModal={setShowDeleteDialog}>
                {pollDeleteId !== null &&
                    <div className={`${styles.deleteDialog} dialog`}>
                        <h1 className={styles.title}>{t('sure_delete_poll')}</h1>
                        <CancelConfirmButtons
                            onCancel={() => setShowDeleteDialog(false)}
                            onConfirm={handleConfirmClick}
                        />
                    </div>
                }
            </Modal>
        </>
    );
};

export default TablePollActions;